import { render, staticRenderFns } from "./BGoogleMapAutocomplete.vue?vue&type=template&id=f1be2fc8&scoped=true"
import script from "./BGoogleMapAutocomplete.vue?vue&type=script&lang=js"
export * from "./BGoogleMapAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1be2fc8",
  null
  
)

export default component.exports